import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserModel } from '../models/user-model';
import { CognitoFederatedIdentity } from '../models/cognito-model';
import { SentryService } from './sentry.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private sentryService: SentryService) {
  }

  verifyOpenToken(openToken): Observable<CognitoFederatedIdentity> {
    return this.http.post<CognitoFederatedIdentity>(`${environment.baseUrl}/openToken`, {
      operationType: "verifyOpenToken",
      openToken
    }, { headers: { Anonymous: 'Anonymous' } });
  }

  updateUserDataDb(updatedData): Promise<UserModel> {
    return new Promise((resolve, reject) => {
      this.http.put<UserModel>(`${environment.baseUrl}/putUser`, updatedData).subscribe(data => {
        resolve(data);
      }, err => {
        this.sentryService.errorHandling(err, 'user-service', err.error.message);
      });
    });
  }

  getUserByEmail(userData = null): Observable<UserModel> {
    const herdersOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + userData ? userData.accessToken : ''
      })
    };
    return this.http.get<UserModel>(`${environment.baseUrl}/getUser`, herdersOptions).pipe(
      catchError(err => {
        this.handleError(err);
        return throwError(err);
      })
    );
  }

  getUserData(): UserModel {
    if (typeof Storage !== "undefined") {
      return JSON.parse(localStorage.getItem('userData'));
    } else {
      return null;
    }
  }

  clearUserData(): void {
    if (typeof Storage != "undefined") {
      localStorage.removeItem('userData');
    }
    else {
      throw ('Sorry! Your browser not support web storage')
    }
  }

  setUserData(userData: UserModel): void {
    if (typeof Storage != "undefined") {
      localStorage.setItem('userData', JSON.stringify(userData));
    }
    else {
      throw ('Sorry! Your browser not support web storage')
    }
  }

  updateUserData(newData: UserModel): UserModel {
    this.clearUserData();
    this.setUserData(newData);
    return newData;
  }

  getOpenToken(): Observable<object | {}> {
    const userData = this.getUserData();
    return this.http.post<object>(`${environment.baseUrl}/openToken`, {
      operationType: 'getOpenToken',
      refreshToken: userData ? userData.refreshToken : '',
      accessToken: userData ? userData.accessToken : '',
      idToken: userData ? userData.idToken : ''
    }).pipe(
      catchError(err => {
        this.handleError(err);
        return throwError(err);
      })
    );
  }
  subscriptionIsExpired(): boolean {
    if (this.getUserData()) {
      const current = new Date();
      const msPerDay = 60 * 1000 * 60 * 24;
      const elapsed = (this.getUserData().subscriptionExpirationDate * 1000) - current.getTime();
      let timeAgo = Math.round(elapsed / msPerDay);
      if (timeAgo <= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  public handleError(error) {
    this.sentryService.errorHandling(error, 'user-service', error.error.message ? error.error.message : (error.message ? error.message : error));
    return throwError(error);
  }
}
